/**
 * Matches an equity/underlying symbol against a row symbol that may be the
 * equity itself or an OCC option symbol for that underlying (e.g. `AAPL`
 * matches `AAPL` and `AAPL260116C00150000`). Mirrors the filter used by the
 * v2 OrdersTable so grouped positions/orders widgets stay consistent.
 */
export const matchesUnderlying = (
  underlying: string,
  rowSymbol: string,
): boolean => {
  const normalized = underlying.trim().toUpperCase();
  if (!normalized) {
    return true;
  }
  const pattern = new RegExp(`^${normalized}(\\d{6}[CP]\\d{8})?$`);
  return pattern.test(rowSymbol.toUpperCase());
};
